import React, { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Tooltippy } from "../../../actions/Tippy";
import { isJson } from "../../../utils/isJson";
import { handleCopy } from "../../../utils/handleCopy";
import { createJSON } from "../../../utils/createJSON";
import { renderCorrectMidia } from "../../../utils/renderCorrectMidia";

export const useSideDetails = (selectedChat) => {
  const InfoUsers = useSelector((state) => state.informationusers);
  const DetailsFileSharedIn = useSelector((state) => state.detailsfileshared);
  const DetailsAnotations = useSelector((state) => state.detailsanotations);
  const DetailsMarkstar = useSelector((state) => state.detailsmarkstars);
  const [copyFeedback, setCopyFeedback] = useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const copyTimerRef = useRef(null);

  const MenuBot = useMemo(() => {
    try {
      const hasMenuBot =
        Boolean(selectedChat) &&
        Boolean(selectedChat.menubot) &&
        typeof selectedChat.menubot === "string";
      if (!hasMenuBot) return [];
      let newMenuBot = selectedChat.menubot.split("~¿");
      let verifierName = newMenuBot[0].split(":");
      // if(verifierName[0] === "Nome" || verifierName[0] === "NOME"){
      //     MenuBot.shift();
      // }
      newMenuBot.forEach((obj, index) => {
        var value = obj.split(":");
        if (value[0] === "DisplayName") {
          newMenuBot.splice(index, 1);
        }
        if (value[1] === selectedChat.cliente && obj === null) {
          newMenuBot.splice(index, 1);
        }
      });
      return newMenuBot;
    } catch (error) {
      return [];
    }
  }, [selectedChat]);
  const MenuBotContactInfos = useMemo(() => {
    try {
      const hasMenuBot = Array.isArray(MenuBot) && MenuBot.length > 0;
      if (!hasMenuBot) return [];
      return MenuBot.filter((info) => {
        const isVoice =
          Boolean(selectedChat) &&
          Boolean(selectedChat.idmidia) &&
          (selectedChat.idmidia === "1" || selectedChat.idmidia === 1);
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("nome na agenda:")
        )
          return true;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("ddi_e164:")
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("nome social:") &&
          isVoice
        )
          return true;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("código externo:") &&
          isVoice
        )
          return true;
        if (
          isVoice &&
          typeof info === "string" &&
          (info.toLowerCase().includes("tipo de chamada: ativo") ||
            info.toLowerCase().includes("tipo de chamada: receptivo"))
        )
          return true;
        if (
          isVoice &&
          typeof info === "string" &&
          info.toLowerCase().includes("tel origem: ")
        )
          return true;
        return false;
      });
    } catch (error) {
      console.log("MenuBotContactInfos ERROR: ", error);
      return [];
    }
  }, [MenuBot, selectedChat]);
  const MenuBotEnterprise = useMemo(() => {
    try {
      const hasMenuBot = Array.isArray(MenuBot) && MenuBot.length > 0;
      if (!hasMenuBot) return [];
      return MenuBot.filter((info) => {
        const isVoice =
          Boolean(selectedChat) &&
          Boolean(selectedChat.idmidia) &&
          (selectedChat.idmidia === "1" || selectedChat.idmidia === 1);
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("empresa na agenda:")
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("empresa:") &&
          isVoice
        )
          return true;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("código externo empresa:") &&
          isVoice
        )
          return true;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("cnpj:") &&
          isVoice
        )
          return true;

        return false;
      });
    } catch (error) {
      console.log("MenuBotEnterprise ERROR: ", error);
      return [];
    }
  }, [MenuBot, selectedChat]);
  const MenuBotInformations = useMemo(() => {
    try {
      const hasMenuBot = Array.isArray(MenuBot) && MenuBot.length > 0;
      if (!hasMenuBot) return [];
      return MenuBot.filter((info) => {
        const isVoice =
          Boolean(selectedChat) &&
          Boolean(selectedChat.idmidia) &&
          (selectedChat.idmidia === "1" || selectedChat.idmidia === 1);

        if (
          typeof info === "string" &&
          info.toLowerCase().includes("nome na agenda:")
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("ddi_e164:")
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("empresa na agenda:")
        )
          return false;
        if (typeof info === "string" && info.toLowerCase().includes("empresa:"))
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("código externo:") &&
          isVoice
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("nome social:") &&
          isVoice
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("empresa:") &&
          isVoice
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("código externo empresa:") &&
          isVoice
        )
          return false;
        if (
          typeof info === "string" &&
          info.toLowerCase().includes("cnpj:") &&
          isVoice
        )
          return false;
        if (
          isVoice &&
          typeof info === "string" &&
          (info.toLowerCase().includes("tipo de chamada: ativo") ||
            info.toLowerCase().includes("tipo de chamada: receptivo"))
        )
          return false;
        if (
          isVoice &&
          typeof info === "string" &&
          info.toLowerCase().includes("tel origem: ")
        )
          return false;
        return true;
      });
    } catch (error) {
      console.log("MenuBotInformations ERROR: ", error);
      return [];
    }
  }, [MenuBot, selectedChat]);
  const hasEnterpriseAdditionalInfos =
    Boolean(selectedChat) &&
    Array.isArray(selectedChat.enterpriseAdditionalInfos) &&
    selectedChat.enterpriseAdditionalInfos.length > 0;

  const hasResponsavelPor =
    Boolean(selectedChat) &&
    Boolean(selectedChat.responsavelPor) &&
    Array.isArray(selectedChat.responsavelPor) &&
    selectedChat.responsavelPor.length > 0;

  const hasContactAdditionalInfos =
    Boolean(selectedChat) &&
    Array.isArray(selectedChat.contactAdditionalInfos) &&
    selectedChat.contactAdditionalInfos.length > 0;

  const showCopyFeedback = (x, y) => {
    if (copyTimerRef.current) {
      clearTimeout(copyTimerRef.current);
    }

    setCopyFeedback({ visible: true, x, y });

    copyTimerRef.current = setTimeout(() => {
      setCopyFeedback({ visible: false, x: 0, y: 0 });
      copyTimerRef.current = null;
    }, 1200);
  };

  const renderDetails = (description, isBodyJson) => {
    //(contentWithJson)
    if (!isBodyJson && description) {
      return (
        <Tooltippy content={createJSON(description)}>
          <span
            onClick={(e) => {
              const isCopied = handleCopy(createJSON(description));
              if (isCopied) {
                showCopyFeedback(e.clientX, e.clientY);
              }
            }}
          >
            {createJSON(description)}
          </span>
        </Tooltippy>
      );
    }
    if (isBodyJson && description && isJson(description)) {
      const json = JSON.parse(description);
      return json.map((item, index) => {
        return (
          <Tooltippy
            key={`${index}--${item.id}`}
            content={createJSON(item.label)}
          >
            <div
              className="render-details-midia-id"
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              {Boolean(item.midiaId) && (
                <div>{renderCorrectMidia[item.midiaId]}</div>
              )}
              <span
                onClick={(e) => {
                  const isCopied = handleCopy(createJSON(item.label));
                  if (isCopied) {
                    showCopyFeedback(e.clientX, e.clientY);
                  }
                }}
              >
                {createJSON(item.label)}
              </span>
            </div>
          </Tooltippy>
        );
      });
    }

    return "";
  };

  return {
    InfoUsers,
    DetailsFileSharedIn,
    DetailsAnotations,
    DetailsMarkstar,
    hasEnterpriseAdditionalInfos,
    hasContactAdditionalInfos,
    MenuBot,
    MenuBotContactInfos,
    MenuBotEnterprise,
    MenuBotInformations,
    copyFeedback,
    hasResponsavelPor,
    showCopyFeedback,
    renderDetails,
  };
};
